import { fromJS } from 'immutable';
import * as constants from './constants';

const defaultState = fromJS({
    routerMateData: null,
    loading: false,

    userInfo: null,  //用房基本信息

    userRoute: null,//用户权限菜单信息
});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
    console.log(action)
    switch (action.type) {
        //路由元数据
        case constants.ROUTER_DATA:
            return state.set('routerMateData', action.data);

        //加载层状态
        case constants.LOADING_STATE:
            return state.set('loading', action.data);

        //用户信息
        case constants.USER_INFO_DATA:
            return state.set('userInfo', action.data);
        //用户菜单信息
        case constants.USER_ROUTE_DATA:

            return state.set('userRoute', action.data);
        default:
            return state;
    }
};
